const taskData = [
  {
    id: 1,
    name: "Cook a delicious dinner",
    completed: false,
  },
  {
    id: 2,
    name: "Clear blockage in the sink",
    completed: false,
  },
  {
    id: 3,
    name: "Washing white linen",
    completed: false,
  },
  {
    id: 4,
    name: "Defrost refrigerator",
    completed: false,
  },
];

export default taskData;
